export * from './theme-foundation-core.js?rev=20260906-search-qa';

// Preload the lightweight Quick View controller/module graph, then seed only the
// first visible product section response during idle. This keeps the initial
// interaction off the module/network cold path without competing with LCP by
// prefetching the whole grid.
const prewarmQuickViewController = () => {
  const triggers = [...(document.querySelectorAll?.('[data-quick-view-trigger]') ?? [])];
  if (!triggers.length) return;

  const load = async () => {
    try {
      await import('./quick-view-lazy.js');

      const viewportHeight = globalThis.innerHeight || document.documentElement?.clientHeight || 0;
      const trigger = triggers.find((node) => {
        const rect = node.getBoundingClientRect?.();
        return rect && rect.bottom > 0 && rect.top < viewportHeight;
      }) ?? triggers[0];
      const href = trigger?.href || trigger?.getAttribute?.('href');
      if (!href || typeof globalThis.fetch !== 'function') return;

      const url = new URL(href, globalThis.location?.href ?? document.baseURI);
      if (url.origin !== globalThis.location?.origin || !url.pathname.includes('/products/')) return;
      url.searchParams.set('section_id', 'quick-view-product');

      const seedFirstQuickViewResponse = () => {
        void globalThis.fetch(url.href, {
          headers: { Accept: 'text/html' },
          cache: 'default',
          credentials: 'same-origin',
        }).then((response) => response.ok ? response.text() : null).catch(() => {});
      };

      if ('requestIdleCallback' in globalThis) globalThis.requestIdleCallback(seedFirstQuickViewResponse, { timeout: 900 });
      else globalThis.setTimeout(seedFirstQuickViewResponse, 250);
    } catch {}
  };

  if ('requestIdleCallback' in globalThis) globalThis.requestIdleCallback(() => void load(), { timeout: 250 });
  else globalThis.setTimeout(() => void load(), 0);
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prewarmQuickViewController, { once: true });
else prewarmQuickViewController();

try {
  const params = new URLSearchParams(globalThis.location?.search ?? '');
  const diagnosticsEnabled = params.get('perf_diag') === '1' || globalThis.Shopify?.designMode === true;
  if (diagnosticsEnabled) {
    void import('./muaazon-perf-instrumentation.js').then(() => import('./muaazon-perf-diagnostics.js')).catch(() => {});
  }
} catch {}
